/**
 * Feature flags for the frontend.
 * Set to `false` to hide a feature from the UI without removing the code.
 */

export const FEATURE_FLAGS = {
  /** Show the tracking page (superadmin activity analytics) */
  TRACKING_ENABLED: false,
  /**
   * Show the "3D" tab on the door detail page (exploded, interactive CAD viewer).
   *
   * Keep this off until the business manifests hold real data: the geometry is correct, but the
   * part references and descriptions in `libs/shared/src/models/cad/` are still placeholders.
   */
  DOOR_3D_VIEWER_ENABLED: true,
  /** Show the AI agent panel (superadmin only) */
  AI_AGENT_ENABLED: true,
} as const;
